import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { AdBlockErrorDialogComponent } from './components/adblock-error-dialog/adblock-error-dialog.component';
import { CouponSnackBarComponent } from './components/coupon-snack-bar/coupon-snack-bar.component';
import { DisabledMethodDialogComponent } from './components/disabled-method-dialog/disabled-method-dialog.component';
import {
  PaymentDetailsNotConsistentDialogComponent,
} from './components/payment-details-not-consistent-dialog/payment-details-not-consistent-dialog.component';
import { PaymentExpandableMenuComponent } from './components/payment-expandable-menu/payment-expandable-menu.component';
import { PaymentMethodComponent } from './components/payment-method/payment-method.component';
import { RemoveFromCartDialogComponent } from './components/remove-from-cart-dialog/remove-from-cart-dialog.component';
import { LastPaymentEntryComponent } from './containers/last-payment-entry/last-payment-entry.component';
import { PayComponent } from './containers/pay/pay.component';
import {
  PaymentDetailsNotConsistentDialogEntryComponent,
} from './containers/payment-details-not-consistent-dialog-entry/payment-details-not-consistent-dialog-entry.component';
import { PaymentHistoryComponent } from './containers/payment-history/payment-history.component';
import {
  NewCustomerBillerInfoSnackBarComponent,
} from './components/new-customer-biller-info-snack-bar/new-customer-biller-info-snack-bar.component';
import {
  EmptyCartDisabledMethodDialogComponent,
} from './components/empty-cart-disabled-method-dialog/empty-cart-disabled-method-dialog.component';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { ContainerComponent } from '../shared/components/container/container.component';
import { EmptyStateComponent } from '../shared/components/empty-state/empty-state.component';
import { SecondaryToolbarComponent } from '../shared/components/secondary-toolbar/secondary-toolbar.component';
import { TagListFilterComponent } from '../shared/components/tag-list-filter/tag-list-filter.component';
import { LoadingComponent } from '../shared/components/loading/loading.component';

@NgModule({
  declarations: [
    PayComponent,
    PaymentHistoryComponent,
    PaymentMethodComponent,
    RemoveFromCartDialogComponent,
    PaymentDetailsNotConsistentDialogEntryComponent,
    PaymentDetailsNotConsistentDialogComponent,
    PaymentExpandableMenuComponent,
    LastPaymentEntryComponent,
    DisabledMethodDialogComponent,
    AdBlockErrorDialogComponent,
    CouponSnackBarComponent,
    NewCustomerBillerInfoSnackBarComponent,
    EmptyCartDisabledMethodDialogComponent,
  ],
  imports: [CommonModule, RouterModule, SharedModule,
    NgxMaskDirective, NgxMaskPipe, ContainerComponent,
    EmptyStateComponent, SecondaryToolbarComponent, TagListFilterComponent, LoadingComponent,
  ],
  providers: [provideNgxMask()],
})
export class PayModule {
}
